export default __webpack_public_path__ + "static/media/lp-logo.09338e26.png";